import { format as uikFormat } from '@appd/uik';

export const parseDateTime = (timestamp: string | number): number => {
  return typeof timestamp === 'string' ? Date.parse(timestamp) : timestamp;
};

export const getDisplayDate = (timestamp: string): string => {
  const today = new Date();
  const yesterday = new Date(today);

  yesterday.setDate(yesterday.getDate() - 1);

  const requestDate = new Date(timestamp);

  if (
    requestDate.getFullYear() == today.getFullYear() &&
    requestDate.getMonth() == today.getMonth() &&
    requestDate.getDate() == today.getDate()
  ) {
    return 'Today' + ', ' + requestDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else if (
    requestDate.getFullYear() == yesterday.getFullYear() &&
    requestDate.getMonth() == yesterday.getMonth() &&
    requestDate.getDate() == yesterday.getDate()
  ) {
    return 'Yesterday' + ', ' + requestDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else {
    return uikFormat.dateTime.longWithWeekday(timestamp).replace(' at', ',');
  }
};
